import styled, { css } from 'styled-components';

import ArrowRight from 'components/Icons/ArrowRight';
import colors from 'utils/colors';

import { TabItem as TabItemProps } from './interfaces';

export const Wrapper = styled.div`
  width: 100%;
`;

export const Tabs = styled.div`
  display: flex;
  width: 100%;
`;

const paddingStyle = css`
  padding: 24px 16px;
`;

export const Header = styled.div`
  ${paddingStyle}
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: solid 2px transparent;
  background-color: ${colors.white};
  transition-property: background-color, border-color;
  transition-duration: 150ms;

  :hover {
    cursor: pointer;
  }
`;

export const Title = styled.div`
  padding-left: 10px;
`;

export const Content = styled.div`
  padding: 45px 50px 50px;
  color: ${colors.blueGrey};
`;

export const ArrowIcon = styled(ArrowRight)`
  width: 15px;
  height: 15px;
  box-sizing: content-box;

  &:before,
  &:after {
    box-sizing: content-box;
  }
`;

export const TabItem = styled.button<TabItemProps>`
  font-family: VIC;
  font-size: 1.185rem;
  font-weight: ${props => (props.active ? 700 : 600)};
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  flex-grow: 1;
  border-bottom: 2px solid ${props => (props.active ? colors.white : colors.blueGrey10)};
  border-right: 2px solid ${colors.blueGrey10};
  border-left: none;
  border-top: none;
  padding: 0;
  background-color: ${props => (props.active ? colors.white : colors.blueGrey)};

  :last-child,
  :last-child&:hover {
    border-right: none;
  }

  :focus {
    outline: none;

    ${Header} {
      border-top-color: ${props => (props.active ? colors.orange : colors.blueGrey)};
      background-color: ${props => (props.active ? colors.orange10 : colors.blueGrey25)};
    }

    ${Title} {
      color: ${props => (props.active ? colors.brown : colors.blueGrey)};
    }

    div > svg > path {
      fill: ${props => (props.active ? colors.brown : colors.blueGrey)};
    }
  }

  ${Header} {
    border-top: 6px solid ${props => (props.active ? colors.orange : 'transparent')};
  }

  ${Title} {
    color: ${props => (props.active ? colors.orange : colors.blueGrey)};
  }

  ${props =>
    !props.active &&
    css`
      &:hover {
        border-right: 2px solid ${colors.blueGrey10};
        ${Header} {
          background-color: ${colors.blueGrey25};
          border-top: 6px solid ${colors.blueGrey};
        }

        ${Title} {
          color: ${colors.blueGrey};
        }
      }
    `};
`;
